import { render } from "./MovieCard.vue?vue&type=template&id=53c25189"
import script from "./MovieCard.vue?vue&type=script&lang=js"
export * from "./MovieCard.vue?vue&type=script&lang=js"
script.render = render

export default script